import React,{useState, useEffect} from "react";
import './Searchnav.css';
import WelcomeName from "./WelcomeName";
import { baseUrl } from "../Constant";
import axios from "axios";
function Searchnav() {
    const [temp, setTemp] = useState("");
    useEffect(() => {
        const homeUrl = async () => {
            const result = await axios.get(`${baseUrl}/homeUrl`)
            const { data: { Url } } = result
            console.log("test", Url)
            setTemp(Url)
        }
        homeUrl()
    }, []);
    return (
        <>
            <div className="searchnav-container">
                <div className="searchnav-wrap">
                    <div className="searchnav-row">
                        <div className="searchnav-box">
                            <img src={process.env.PUBLIC_URL + "/images/Acc_Logo_Black_Purple_RGB.png"} className="acc-logo" alt="logo" />
                            <p className="desktop-tag"><span>Learning & Talent Transformation</span> <br /> <p className="desktop-tag-1">Training Nomination Request</p></p>
                            <p className="mobile-tag"><span>L&TT</span> <br /> <p className="mobile-tag-1">TNR</p></p>
                            <a className="L_tt_anchortag" href={temp ? temp : ''}
                                target="_blank">L&TT Home</a>
                        </div>
                    </div>
                    <div className="searchnav-row">
                        <div className="searchnav-box" style={{ textAlign: 'right', marginTop: '10px' }}>
                            <WelcomeName />
                            <img src={process.env.PUBLIC_URL + "/images/Avatar.png"} className="user-img" alt="user-image" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Searchnav
